import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTwoColumnsContainerComponent } from './fi-two-columns-container.component';
import { FiWhenScrolledModule } from '../fi-directives/when-scrolled/when-scrolled.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
    imports: [CommonModule, FiWhenScrolledModule, ScrollingModule],
    declarations: [FiTwoColumnsContainerComponent],
    exports: [FiTwoColumnsContainerComponent],
})
export class FiTwoColumnsContainerModule {}
